module.exports = __webpack_public_path__ + "img/banner_playstation.eee7c61b.png";